<template>
    <div class="p-3">
        <el-card header="Relatórios Financeiros">
            <el-form label-position="top" :disabled="getting" class="p-1">
                <el-row :gutter="30">
                    <el-col :sm="24" :md="8">
                        <el-form-item label="Datas limite" required>
                            <el-date-picker type="daterange" unlink-panels range-separator="-" start-placeholder="Desde" end-placeholder="Até" v-model="range" />
                        </el-form-item>
                    </el-col>
                    <el-col :sm="24" :md="8">
                        <el-form-item label="Vendido por">
                            <el-select v-model="seller_id" name="seller_id" :clearable="false">
                                <el-option :value="-1" label="Todos vendedores">
                                    Todos vendedores
                                </el-option>
                                <el-option v-for="seller in sellers" :key="seller.id" :value="seller.id" :label="seller.name">
                                    {{seller.name}}
                                </el-option> 
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="24" :md="8">
                        <el-form-item label="Aplicar filtros">
                            <el-button type="primary" plain icon="Search" :loading="getting||loading" @click="submit">
                                Procurar
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-skeleton :rows="12" animated :loading="loading">
                <PersonalTable :loading="loading" :height="450" :showRows="10" :cols="[
                    {label: 'Cod', prop: 'id'},
                    {label: 'Estado', prop: 'status'},
                ]" :data="reports">
                    <el-table-column label="Cliente" class-name="col-auto" :min-width="150">
                        <template #default="data">
                            {{data.row.user.name}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Entregador" class-name="col-auto" :min-width="150">
                        <template #default="data">
                            {{data.row.seller.name}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Total" class-name="col-auto" :min-width="100">
                        <template #default="data">
                            <label class="text-success fw-bold">
                                {{data.row.total}} MZN 
                            </label>
                            <label class="col-12 mutted small p-0">
                                {{ data.row.products.length }} produtos
                            </label>
                        </template>
                    </el-table-column>
                    <el-table-column label="Solicitou em" class-name="auto" :min-width="100">
                        <template #default="data">
                            {{new Date(data.row.created_at).toLocaleString()}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Detalhes">
                        <template #default="data">
                            <span class="p-2">
                                <el-button type="primary" tag="router-link" :to="'/requests/' + data.row.id" icon="View" title="Ver mais"></el-button>
                            </span>
                        </template>
                    </el-table-column>
                </PersonalTable>
            </el-skeleton>
            <template #footer v-if="total">
                Total geral: <label class="text-success fw-bold">
                    {{total}} MZN 
                </label>
            </template>
        </el-card>
    </div>
</template>

<script lang="ts" setup>
    import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus';
    // import { useStore } from 'vuex';
    import { User } from '@/services/types';

    const loading = ref<boolean>(true)
    const getting = ref<boolean>(false)
    const reports = ref<Array<any>>([])
    const from = new Date()
    from.setDate((new Date()).getDate() - 7)
    const range = ref<Array<Date>>([
        from, new Date()
    ])
    const total = ref<number|undefined>(undefined)
    const sellers = ref<Array<User>>([])
    const seller_id = ref<number>(-1)

    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const getReports = async (range: Array<Date>, seller_id: number | undefined = undefined) => {
        getting.value = true
        const params = new URLSearchParams()
        params.append("from", formatDate(range[0]))
        params.append("to", formatDate(range[1]))
        if (seller_id) {
            seller_id && params.append('seller_id', seller_id.toString())
        }
        
        const res = await Api.get('admin/reports?' + params.toString())
        console.log(res)
        if (res.status == 200) {
            reports.value = res.data.requests
            total.value = res.data.total
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
            for(let key in res.data.errors) {
                ElMessage.error({message: res.data.errors[key]})
            }
        }
        getting.value = false
    }

    const submit = async () => {
        await getReports(range.value, seller_id.value <= 0 ? undefined:seller_id.value)
    }

    onBeforeMount(async () => {
        loading.value = true
        const res = await Api.get('admin/sellers')
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ao buscar os entregadores ' + res.data.message})
            return
        }
        sellers.value = res.data.sellers

        await getReports(range.value)
        loading.value = false
    })
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
